import React from "react"
import icons1 from '../../pageComponents/images/page12/icons1-page12.svg'
import icons2 from '../../pageComponents/images/page12/icons2-page12.svg'
import number1 from '../../pageComponents/images/page12/number-1.svg'
import number2 from '../../pageComponents/images/page12/number-2.svg'
import number3 from '../../pageComponents/images/page12/number-3.svg'
import icon1 from '../../pageComponents/images/page12/icon1.svg'
import icon2 from '../../pageComponents/images/page12/icon2.svg'
import icon3 from '../../pageComponents/images/page12/icon3.svg'

const Page12Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div>
          <div className='mt-5 d-flex'>
            <div className='title-rectangle'></div>
            <div className='ml-1 line-height-20 font-16'>Valutazione</div>
          </div>
          <div className='mt-2 font-family-acumin font-22 line-height-28 font-weight-500'>
            Edison valuta quanti e
            quali veicoli della flotta possono essere sostituiti
            da vetture elettriche, in
            base alle richieste di
            mobilità dell’azienda.
          </div>
          <div className='mt-2 font-16 line-height-20'>
            Questo passaggio avviene monitorando e analizzando in
            dettaglio i dati cruciali e il comportamento dell’attuale flotta
            aziendale, al fine di identificarne la configurazione
            (totalmente elettrica o ibrida) e i tipi di veicoli.
          </div>
          <div className='mt-4 text-center'>
            <img src={icons1} alt='Icons' />
          </div>
        </div>
        <div className='mt-5 mb-5 barra-arancio'></div>
        <div>
          <div className='d-flex'>
            <div className='title-rectangle'></div>
            <div className='ml-1 line-height-20 font-16'>Simulazione</div>
          </div>
          <div className='mt-2 font-family-acumin font-22 line-height-28 font-weight-500'>
            Edison simula i viaggi dell’azienda con un veicolo elettrico di riferimento,
            tenendo conto di tutti i fattori cruciali che ne impattano l’autonomia.
          </div>
          <div className='mt-2 font-16 line-height-20'>
            Questa attività permette di comprendere
            e risolvere le inefficienze di mobilità e avere
            l’indicazione scientifica delle azioni da
            intraprendere per una gestione efficace
            della flotta. Il tutto, avviene analizzando
            sei parametri fondamentali.
          </div>
          <div className='mt-4 text-center'>
            <img src={icons2} alt='Icons' />
          </div>
        </div>
        <div className='mt-5 mb-5 barra-arancio'></div>
        <div className='md:d-flex md:justify-content-center'>
          <div className='md:mr-1'>
            <img src={number1} alt='Number 1' />
          </div>
          <div className='mt-1 d-flex align-items-center'>
            <div className='font-16 line-height-20'>
              <strong>Reale Mobilità.</strong> Edison<br />monitora e analizza i viaggi<br />reali di ciascun veicolo,<br />
              senza affidarsi a stime o<br />semplici medie.
            </div>
            <div className='ml-3'>
              <img src={icon1} alt='Icon 1' height='54' />
            </div>
          </div>
        </div>
        <div className='mt-4 md:d-flex md:justify-content-center'>
          <div className='md:mr-1'>
            <img src={number2} alt='Number 2' />
          </div>
          <div className='mt-1 d-flex align-items-center'>
            <div className='font-16 line-height-20'>
              <strong>Ottimizzazione Percorso.</strong><br />
              La scelta di percorsi non<br />ottimizzati dai sistemi di<br />
              navigazione può impattare<br />
              l’autonomia del veicolo.
            </div>
            <div className='ml-3'>
              <img src={icon2} alt='Icon 2' height='49' />
            </div>
          </div>
        </div>
        <div className='mt-4 md:d-flex md:justify-content-center'>
          <div className='md:mr-1'>
            <img src={number3} alt='Number 3' />
          </div>
          <div className='mt-1 d-flex align-items-center'>
            <div className='font-16 line-height-20'>
              <strong>Stile di Guida.</strong><br />
              Il comportamento del<br />guidatore può ridurre fino<br />
              al 24 per cento l’autonomia<br />dell’auto elettrica.
            </div>
            <div className='ml-3'>
              <img src={icon3} alt='Icon 3' height='36' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page12Mobile
